module.exports = __webpack_public_path__ + "static/media/game-board.21ad287d.svg";